export const getErrorMessage = (statusCode) => {
  switch (statusCode) {
    case 400:
      return "申し訳ございません。不正な要求がされました。";
    case 401:
      return "ログイン情報が正しくありません。再度お試しください。";
    case 403:
      return "このページへのアクセスは許可されていません。";
    case 404:
      return "お探しのページが見つかりませんでした。";
    case 500:
      return "システム内部で問題が発生しました。しばらくお待ちください。";
    case 501:
      return "この操作は現在サポートされていません。";
    case 502:
      return "システムの接続に問題が発生しました。";
    case 503:
      return "サービスが一時的に利用できません。後ほどお試しください。";
    case 504:
      return "サーバーとの接続がタイムアウトしました。";
    case 505:
      return "使用しているブラウザのバージョンが古い可能性があります。";
    default:
      return "予期しないエラーが発生しました。";
  }
};
